import { makeStyles } from '@material-ui/core/styles'

export const idleTimerStyles = makeStyles((theme) => ({
  sessionContent: {
    [theme.breakpoints.down(400)]: {
      height: 'calc(100dvh - 216px)',
      maxHeight: 336,
    },
  },
  sessionTimeoutImage: {
    width: 500,
    height: 'auto',
    [theme.breakpoints.down('sm')]: {
      width: '100%',
    },
  },
}))

export default idleTimerStyles
